const SET_LIST = (state, obj) => {
  state.list = obj
}

export default {
  SET_LIST
}



// WEBPACK FOOTER //
// ./src/features/assignment_request/store/mutations.js